import CrudPage from "./CrudPage";

const fields = [
  { name: "name", label: "Robot Name", required: true },
  { name: "year", label: "Season / Year", required: true, placeholder: "2025-2026" },
  { name: "photo_url", label: "Photo", type: "image", span: "full" },
  { name: "description", label: "Description", type: "textarea", span: "full" },
  { name: "specs", label: "Specs (one per line)", type: "list", span: "full" },
  { name: "is_current", label: "Current Build", type: "checkbox", checkboxLabel: "Mark as current season's robot" },
];

const columns = [
  { key: "name", label: "Name" },
  { key: "year", label: "Year" },
  { key: "is_current", label: "Current", render: (r) => (r.is_current ? "✓" : "—") },
];

export default function AdminRobots() {
  return (
    <CrudPage
      title="Robots"
      endpoint="/robots"
      fields={fields}
      columns={columns}
      testidPrefix="robots"
      emptyDefaults={{ name: "", year: "", photo_url: "", description: "", specs: [], is_current: false }}
    />
  );
}
